import React, {ReactElement} from "react";
import {BaseSectionData} from "../../../../vantage-shared/page-components/types";
import {FormGenContainer} from "../../../../shared/FormGenContainer";

export function SidebarContentAttributes(props: {
  sectionData: BaseSectionData,
  onSectionDataChanged: () => void
}): ReactElement {
  return <FormGenContainer content={props.sectionData} onContainerWillSave={props.onSectionDataChanged}/>;
}